 <span class="subtitle" [textContent]="text"></span>
